import React from 'react';
import PropTypes from 'prop-types';
import {
  SelectField,
  DateField,
  ReferenceField,
  TextField,
  translate as translateComponent,
} from 'react-admin';

import { GridCard, ShowGrid, TimeField } from '../../components';

import ShowActions from './detail/ShowActions';

const Show = ({ translate, ...props }) => {
  return (
    <ShowGrid
      {...props}
      actions={<ShowActions />}
      titleSource={['account_name', 'cleaner_fullname']}
    >
      <GridCard
        title={translate('resources.affectation.card_title.info')}
        xs={12}
      >
        <ReferenceField source="cleaner_id" reference="cleaner" link="show">
          <TextField source="fullname" />
        </ReferenceField>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="type" />
        <DateField source="start_date" />
        <DateField source="end_date" />
      </GridCard>
      <GridCard
        title={translate('resources.affectation.card_title.schedule')}
        xs={12}
      >
        <TimeField source="start_time" />
        <TimeField source="end_time" />
        <SelectField
          source="monday"
          label="Lundi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="tuesday"
          label="Mardi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="wednesday"
          label="Mercredi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="thursday"
          label="Jeudi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="friday"
          label="Vendredi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="saturday"
          label="Samedi"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
        <SelectField
          source="sunday"
          label="Dimanche"
          choices={[
            { id: true, name: '✅' },
            { id: false, name: '❌' },
          ]}
        />
      </GridCard>
      <GridCard title={translate('resources.affectation.card_title.site')}>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          label="Compte"
          allowEmpty
        >
          <TextField source="name" label="Compte" />
        </ReferenceField>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          label="Adresse"
          allowEmpty
        >
          <TextField source="shipping_address" />
        </ReferenceField>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          allowEmpty
          label="Arrêt"
        >
          <TextField source="transit_stop" />
        </ReferenceField>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          allowEmpty
          label="Manager"
        >
          <TextField source="manager_fullname" />
        </ReferenceField>
        <ReferenceField
          source="account_id"
          reference="account"
          link="show"
          allowEmpty
          label="Opérationnel Client"
        >
          <TextField source="operational_fullname" />
        </ReferenceField>
      </GridCard>
    </ShowGrid>
  );
};

Show.propTypes = {
  translate: PropTypes.func,
};

Show.defaultProps = {
  translate: /* istanbul ignore next */ () => {},
};

export default translateComponent(Show);
